import { Component, ChangeDetectionStrategy, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ORIGINAL_URL_QUERY_PARAM } from '@skyeng/libs/vimbox-core/routing';
import { Location } from '@angular/common';
import { NavigationService } from '../../service/navigation-service';
import { TranslocoModule } from '@ngneat/transloco';
import { TypografModule } from '@skyeng/libs/skypro/misc';
import { DsButtonModule } from '@skyeng/libs/shared/ui-kit-v2/button';

@Component({
  selector: 'app-page-503',
  templateUrl: 'page-503.html',
  styleUrls: ['page-503.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DsButtonModule, TypografModule, TranslocoModule],
})
export class Page503Component implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private location = inject(Location);
  private navigationService = inject(NavigationService);

  ngOnInit(): void {
    // https://github.com/angular/angular/issues/17004#issuecomment-414459149
    const originalUrl = this.activatedRoute.snapshot.queryParams[ORIGINAL_URL_QUERY_PARAM];

    if (originalUrl) {
      this.location.replaceState(originalUrl);
    }
  }

  logout(): void {
    this.navigationService.navigateToLogout();
  }
}
